<template>
  <div>
    <h5>Repair Contact</h5>
    <h6 class="text-uppercase">{{ estimorderDisplayText }} ID: {{ serviceOrderId }}</h6>

    <div>
      <b-row no-gutters>
        <b-col>
          <span v-if="!readonly" class="required-legend float-right p-0">* Required</span>
        </b-col>
      </b-row>
      <b-row class="mb-3 d-flex justify-space-between" no-gutters>
        <div class="w-100">
          <b-form-group
            class="customer-conacts"
            label="Select or Add Contact:"
            label-class="col-head"
            label-for="customerContacts"
          >
            <div class="d-flex w-100 align-items-center">
              <v-select
                id="customerContacts"
                ref="contactSelect"
                :options="activeCustomerContacts"
                :filter-by="filterContacts"
                :clearable="false"
                :get-option-label="item => item.emailAddress"
                select-on-tab
                class="flex-grow-1"
                style="min-width: 400px"
                @input="selectContact($event)"
              >
                <template #option="contact">
                  <span>
                    {{ contact.firstName }} {{ contact.lastName }} | {{ contact.emailAddress }} |
                    {{ contact.phoneNumber | phone }}
                  </span>
                </template>
                <template #selected-option="contact">
                  <span>
                    {{ contact.firstName }} {{ contact.lastName }} | {{ contact.emailAddress }} |
                    {{ contact.phoneNumber | phone }}
                  </span>
                </template>
                <template #list-header>
                  <div class="p-2 border-top">
                    <b-button variant="secondary" size="sm" block @click="editOrAddContact(false)">
                      Add New Contact
                    </b-button>
                  </div>
                </template>
              </v-select>
            </div>
          </b-form-group>
        </div>
      </b-row>
      <div v-if="showInputs">
        <div v-if="repairContact.inactive" style="color: red">Inactive Contact</div>

        <b-row no-gutters>
          <b-col>
            <b-form-group label="First Name:" label-class="col-head" label-for="firstName">
              <div v-if="readonly" class="col-form-label">
                {{ firstName || NA }}
              </div>
              <b-input-group v-else>
                <b-form-input
                  v-model="firstName"
                  :state="!$v.firstName.$error ? null : false"
                  class="rounded"
                ></b-form-input>
                <span class="required-asterisk">*</span>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col class="ml-2">
            <b-form-group label="Last Name:" label-class="col-head" label-for="lastName">
              <div v-if="readonly" class="col-form-label">
                {{ lastName || NA }}
              </div>
              <b-input-group v-else>
                <b-form-input
                  v-model="lastName"
                  :state="!$v.lastName.$error ? null : false"
                  class="rounded"
                ></b-form-input>
                <span class="required-asterisk">*</span>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col>
            <b-form-group label="Phone:" label-class="col-head" label-for="phone">
              <div v-if="readonly" class="col-form-label">
                {{ phoneNumber | phone | nullValueToNA }}
              </div>
              <b-input-group v-else>
                <phone-input v-model="phoneNumber" :state="!$v.phoneNumber.$error ? null : false" class="rounded" />
                <span class="required-asterisk">*</span>
              </b-input-group>
              <div v-show="$v.phoneNumber.$error && !$v.phoneNumber.length" class="error">
                Enter a valid Phone Number of 7 or 10 digits.
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col>
            <b-form-group label="Email Address:" label-class="col-head" label-for="emailAddress">
              <div v-if="readonly" id="emailAddress" class="col-form-label">
                {{ emailAddress || NA }}
              </div>
              <b-input-group v-else>
                <b-form-input
                  v-model="emailAddress"
                  :state="!$v.emailAddress.$error ? null : false"
                  class="rounded"
                ></b-form-input>
                <span class="required-asterisk">*</span>
              </b-input-group>
              <span v-if="!readonly" class="note float-right required-placeholder">
                Phone and/or Email is required.
              </span>
              <div
                v-show="
                  ($v.phoneNumber.$error && !$v.phoneNumber.required) ||
                  ($v.emailAddress.$error && !$v.emailAddress.required)
                "
                class="error"
              >
                Enter a valid Phone Number or Email Address.
              </div>
              <div v-show="$v.emailAddress.$error && !$v.emailAddress.email" class="error">
                Enter a valid Email Address.
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col>
            <b-form-group label="Title:" label-class="col-head" label-for="title">
              <div v-if="readonly" class="col-form-label">
                {{ title || NA }}
              </div>
              <b-input-group v-else>
                <b-form-input v-model="title" class="rounded mr-3"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col>
            <b-form-group label="Comment" label-class="col-head" label-for="comment" class="required-placeholder">
              <div v-if="readonly" class="col-form-label">
                {{ comment || NA }}
              </div>
              <b-textarea v-else id="comment" v-model="comment" class="overflow-auto" size="sm" rows="3" max-rows="4" />
            </b-form-group>
          </b-col>
        </b-row>
        <p
          v-if="!(repairContact.phoneNumber || repairContact.emailAddress) && !unit.isUnitAtVehicareBranch"
          style="color: red"
        >
          Repair Contact is required for all Service Orders
        </p>
      </div>
      <div v-else>
        <div class="d-flex align-items-start">
          <div class="d-flex flex-column h8">
            <div>
              <font-awesome-icon icon="user" class="mr-2" style="color: #798c9b" />
              <span class="ml-1">{{ repairContact.firstName }} {{ repairContact.lastName }}</span>
            </div>
            <div class="mt-1">
              <font-awesome-icon icon="phone" class="mr-2" style="color: #798c9b" />
              <span class="ml-1">{{ repairContact.phoneNumber | phone }}</span>
            </div>
            <div class="mt-1">
              <font-awesome-icon icon="envelope" class="mr-2" style="color: #798c9b" />
              <span class="ml-1">{{ repairContact.emailAddress }}</span>
            </div>
          </div>

          <div v-if="isCsrOrCsm" class="d-flex flex-column justify-content-end h-100 ml-5">
            <b-link v-if="!readonly && contactId > 0" class="ml-5" @click="editOrAddContact(true)">
              {{ 'Edit Contact' }}
            </b-link>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <b-button v-if="!readonly" variant="primary" :disabled="saving" @click="checkDuplicateContacts">
          <div v-show="saving">
            <b-spinner small></b-spinner>
            Saving...
          </div>
          <div v-show="!saving">
            {{ creatingNewContact ? 'Add New Contact and Save' : 'Save Repair Contact' }}
          </div>
        </b-button>
        <b-button v-if="showInputs" variant="secondary" class="ml-2" :disabled="saving" @click="cancelChanges">
          Cancel
        </b-button>
      </div>
      <div class="py-4" />
    </div>
    <duplicate-contacts-modal
      id="DuplicateContactsModalRepair"
      ref="DuplicateContactsModalRepair"
      :duplicates="duplicates"
      :contact="repairContact"
      :is-service-order="true"
      @user-override="onUserOverride"
    />
  </div>
</template>

<script>
// Components
import PhoneInput from '@/shared/components/ui/PhoneInput';
import vSelect from 'vue-select';

// Vuex
import { UnitGetters } from '@/shared/store/unit/types';
import { ServiceOrderActions, ServiceOrderGetters, ServiceOrderMutations } from '@/shared/store/service-order/types';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { UserGetters } from '@/shared/store/user/types';
import { CustomerGetters, CustomerActions } from '@/shared/store/customer/types';
import { required, requiredIf, email } from 'vuelidate/lib/validators';
import ErrorService from '@/shared/services/ErrorService';
import SuccessService from '@/shared/services/SuccessService';
import DuplicateContactsModal from '@/shared/components/DuplicateContactsModal.vue';
import UserAccessMixin from '@/shared/mixins/UserAccessMixin';
const getDefaultContact = () => ({
  firstName: '',
  lastName: '',
  phoneNumber: '',
  emailAddress: '',
  title: '',
  comment: ''
});
export default {
  name: 'ServiceOrderRepairContact',
  components: {
    'phone-input': PhoneInput,
    'v-select': vSelect,
    'duplicate-contacts-modal': DuplicateContactsModal
  },
  mixins: [UserAccessMixin],
  data() {
    return {
      NA: 'N/A',
      saving: false,
      showInputs: false,
      originalContactData: getDefaultContact(),
      creatingNewContact: false,
      duplicates: []
    };
  },
  validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    phoneNumber: {
      required: requiredIf(function () {
        return !this.emailAddress;
      }),
      length: value => !value || value.length == 7 || value.length == 10
    },
    emailAddress: {
      required: requiredIf(function () {
        return !this.phoneNumber;
      }),
      email
    }
  },
  computed: {
    ...mapGetters({
      user: UserGetters.GET_USER_PROFILE,
      unit: UnitGetters.GET_UNIT,
      estimorderDisplayText: ServiceOrderGetters.GET_ESTIMORDER_DISPLAY_TEXT,
      serviceOrder: ServiceOrderGetters.GET_SERVICE_ORDER,
      repairContact: ServiceOrderGetters.GET_REPAIR_CONTACT,
      branchId: ServiceOrderGetters.GET_BRANCH_ID,
      customerContacts: CustomerGetters.GET_CUSTOMER_CONTACTS_LIST,
      duplicateContacts: CustomerGetters.GET_DUPLICATE_CONTACTS
    }),
    ...mapGetters([UserGetters.AUTHORIZE_ROLE]),
    readonly() {
      const myBranchIds = this.user.employeeBranches.map(branch => branch.branchId);
      const branchIsAccessible = myBranchIds.includes(this.branchId);
      return this.$store.state.serviceOrder.serviceOrder.invoiced || !branchIsAccessible;
    },
    isCsrOrCsm() {
      return this[UserGetters.AUTHORIZE_ROLE](['CSR', 'CSM', 'RegionalCSM']);
    },
    unitId() {
      return this.unit.unitId;
    },
    serviceOrderId() {
      return this.serviceOrder.serviceOrderId;
    },
    contactId: {
      get() {
        return this.repairContact.contactId;
      },
      set(value) {
        this.setData('contactId', value);
      }
    },
    firstName: {
      get() {
        return this.repairContact.firstName;
      },
      set(value) {
        this.setData('firstName', value);
      }
    },
    lastName: {
      get() {
        return this.repairContact.lastName;
      },
      set(value) {
        this.setData('lastName', value);
      }
    },
    phoneNumber: {
      get() {
        return this.repairContact.phoneNumber;
      },
      set(value) {
        this.setData('phoneNumber', value);
      }
    },
    emailAddress: {
      get() {
        return this.repairContact.emailAddress;
      },
      set(value) {
        this.setData('emailAddress', value);
      }
    },
    title: {
      get() {
        return this.repairContact.title;
      },
      set(value) {
        this.setData('title', value);
      }
    },
    comment: {
      get() {
        return this.repairContact.comment;
      },
      set(value) {
        this.setData('comment', value);
      }
    },
    activeCustomerContacts() {
      return (
        this.customerContacts?.filter(c => {
          const map = c.customerMaps?.find(m => m.customerId === this.serviceOrder.customer.customerId);
          return !map?.inactiveCustomerContact;
        }) || []
      );
    },
    fields() {
      const sharedOptions = { sortable: true };
      const fields = [
        { key: 'firstName', label: 'First Name', ...sharedOptions },
        { key: 'lastName', label: 'Last Name', ...sharedOptions },
        { key: 'phoneNumber', label: 'Phone Number', ...sharedOptions },
        { key: 'emailAddress', label: 'Email Address', ...sharedOptions },
        { key: 'title', label: 'Title', ...sharedOptions },
        { key: 'comment', label: 'Comments', sortable: false, thStyle: 'width: 40px', tdClass: 'align-middle' }
      ];

      return fields;
    },
    hasChanges() {
      if (!this.originalContactData) {
        return false;
      }
      const fieldsToCompare = ['contactId', 'firstName', 'lastName', 'phoneNumber', 'emailAddress', 'title', 'comment'];
      for (const field of fieldsToCompare) {
        const current = this.repairContact[field] || '';
        const original = this.originalContactData[field] || '';
        if (current !== original) {
          return true;
        }
      }
      return false;
    }
  },
  async created() {
    if (this.serviceOrder.repairContact?.contactId > 0) {
      await this[ServiceOrderActions.FETCH_REPAIR_CONTACT]({
        unitId: this.unitId,
        serviceOrderId: this.serviceOrderId,
        customerId: this.serviceOrder.customer.customerId,
        repairContactId: this.serviceOrder.repairContact?.contactId
      });
      this.cacheContact(this.repairContact);
    }
    this.loading = false;
  },
  methods: {
    ...mapActions([
      ServiceOrderActions.FETCH_REPAIR_CONTACT,
      CustomerActions.CHECK_DUPLICATE_CONTACTS,
      ServiceOrderActions.UPDATE_REPAIR_CONTACT
    ]),
    ...mapMutations([ServiceOrderMutations.SET_PROP, ServiceOrderMutations.SET_REPAIR_CONTACT]),
    cacheContact(contact) {
      this.originalContactData = JSON.parse(JSON.stringify(contact));
    },
    cancelChanges() {
      this[ServiceOrderMutations.SET_REPAIR_CONTACT](this.originalContactData);
      this.cacheContact(this.repairContact);
      this.showInputs = this.creatingNewContact = false;
    },
    filterContacts(option, label, search) {
      return (
        option.firstName?.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        option.lastName?.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        option.emailAddress?.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        option.phoneNumber?.toLowerCase().indexOf(search.toLowerCase()) > -1
      );
    },
    editOrAddContact(isEdit) {
      if (isEdit) {
        this.showInputs = true;
      } else {
        this.creatingNewContact = true;
        this.$refs.contactSelect?.clearSelection();
        if (this.$refs.contactSelect) this.$refs.contactSelect.open = false;
        let con = {
          contactId: 0,
          firstName: '',
          lastName: '',
          emailAddress: '',
          phoneNumber: '',
          title: '',
          comment: '',
          customerContacts: this.customerContacts
        };
        this[ServiceOrderMutations.SET_REPAIR_CONTACT](con);
        this.showInputs = true;
      }
    },
    selectContact(item) {
      if (!item) {
        return;
      }
      const contacts = [];
      this.customerContacts.forEach(contact => {
        contacts.push(contact);
      });
      let con = {
        contactId: item?.contactId,
        firstName: item.firstName,
        lastName: item.lastName,
        emailAddress: item.emailAddress,
        phoneNumber: item.phoneNumber,
        title: item.title,
        comment: item.comment,
        customerContacts: contacts
      };
      this[ServiceOrderMutations.SET_REPAIR_CONTACT](con);
      this.cacheContact(con);
      this.$v.$touch();
      if (this.$v.$anyError) {
        if (
          !this.$v.firstName.$anyError ||
          !this.$v.lastName.$anyError ||
          !this.$v.emailAddress.$anyError ||
          !this.$v.phoneNumber.$anyError
        ) {
          this.showInputs = true;
        }
      }
    },
    onUserOverride() {
      this.save();
    },
    async checkDuplicateContacts() {
      if (this.repairContact?.contactId === 0) {
        let duplicates = await this[CustomerActions.CHECK_DUPLICATE_CONTACTS](this.repairContact);
        if (duplicates?.length > 0) {
          this.duplicates = duplicates;
          this.$refs.DuplicateContactsModalRepair.show(this, this.save);
        } else {
          this.save();
        }
      } else {
        this.save();
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        if (
          !this.$v.firstName.$anyError ||
          !this.$v.lastName.$anyError ||
          !this.$v.emailAddress.$anyError ||
          !this.$v.phoneNumber.$anyError
        ) {
          this.showInputs = true;
        }
        ErrorService.createErrorToast(this, 'Error saving Repair Contact. See indicated fields below.');
        return;
      }
      try {
        this.saving = this.loading = true;
        const params = {
          unitId: this.unit.unitId,
          serviceOrderId: this.serviceOrder?.serviceOrderId ? this.serviceOrder.serviceOrderId : 'create',
          repairContact: this.repairContact,
          customerId: this.unit.customerId
        };
        await this[ServiceOrderActions.UPDATE_REPAIR_CONTACT](params);
        this.$v.$reset();
        this.showInputs = false;
        SuccessService.createSuccessToast(this.$root, `Repair Contact saved successfully.`);
      } catch (error) {
        ErrorService.createErrorToast(this, 'Failed to save Repair Contact.');
      } finally {
        this.cacheContact(this.repairContact);
        this.saving = this.loading = this.creatingNewContact = false;
      }
    },
    setData(key, newValue) {
      let value = { ...this.repairContact };
      value[key] = newValue;
      this[ServiceOrderMutations.SET_PROP]({ key: 'repairContact', value });
    }
  }
};
</script>
<style>
.customer-conacts {
  width: 85%;
}
</style>
